import React from 'react';
import { featuredChairRoles, otherChairRoles } from '../data/boards';
export function ChairLeadership() {
  return <div data-id="element-91" data-mp="3gfhc9jwwg2kr">
      <div className="grid gap-4 md:grid-cols-3" data-id="element-92" data-mp="3gg0s8v2zogw5">
        {featuredChairRoles.map(r => <article key={r.organisation} className="flex flex-col rounded-2xl border border-rule bg-cream-deep p-6 md:p-7" data-id="element-93" data-mp="3uf0iu8a2b5uy">
            <p className="text-sm font-semibold text-wheat" data-id="element-94" data-mp="3qcly1imu1w11">{r.role}</p>
            <h3 className="mt-2 font-serif text-2xl leading-snug text-forest" data-id="element-95" data-mp="32pxdep6fvpgq">{r.organisation}</h3>
            <p className="mb-5 mt-4 text-sm leading-relaxed text-charcoal" data-id="element-96" data-mp="2xrc8wdk5mjmh">{r.summary}</p>
            <p className="mt-auto border-t border-rule pt-4 text-sm tabular-nums text-charcoal-muted" data-id="element-97" data-mp="3bihctruk1y2m">{r.dates}</p>
          </article>)}
      </div>

      <ul className="mt-8 grid sm:grid-cols-2 sm:gap-x-10 xl:grid-cols-3" data-id="element-98" data-mp="2j152iw7f8r25">
        {otherChairRoles.map(r => <li key={r.organisation} className="flex items-baseline gap-3 border-t border-rule py-4" data-id="element-99" data-mp="2eztbcm8wfxru">
            <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-wheat" aria-hidden="true" data-id="element-100" data-mp="14t6fb6e6n69t" />
            <div className="min-w-0" data-id="element-101" data-mp="19rg85acfpus9">
              <h3 className="font-serif text-base leading-snug text-forest" data-id="element-102" data-mp="19qewb3nlh49h">{r.organisation}</h3>
              <p className="mt-0.5 text-sm text-charcoal-muted" data-id="element-103" data-mp="1ejr98giwvmme">
                <span className="text-wheat-dark" data-id="element-104" data-mp="1ji2ioq5anv43">{r.role}</span> · <span className="tabular-nums" data-id="element-105" data-mp="1jgreip7xslcg">{r.dates}</span>
              </p>
            </div>
          </li>)}
      </ul>
    </div>;
}